import { Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from "@angular/material/dialog";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  selector: "countdown-dialog",
  templateUrl: "./CountdownDialog.component.html",
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, TranslateModule],
})
export class CountdownDialog {
  public dialog = inject(MatDialog);
  public countdownDialogData = inject<{ countdown: number }>(MAT_DIALOG_DATA);
  private translate = inject(TranslateService);

  public get countDownText() {
    const count = this.countdownDialogData.countdown;
    const key =
      count === 1
        ? "shared.countdown_dialog.content_one"
        : "shared.countdown_dialog.content_other";
    return this.translate.instant(key, { count });
  }

  close(): void {
    this.dialog.closeAll();
  }
}
